import React, { createContext, useState, useEffect, useCallback } from 'react';
import { getMe, login as apiLogin, logout as apiLogout, getToken, removeToken, fetchCsrfToken } from './api';

export const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Check existing session on mount
  useEffect(() => {
    const token = getToken();
    if (!token) {
      setLoading(false);
      return;
    }
    getMe()
      .then((data) => {
        if (data && data.user) {
          setUser(data.user);
          fetchCsrfToken();
        } else {
          removeToken();
        }
      })
      .catch(() => removeToken())
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (identifier, password) => {
    const data = await apiLogin(identifier, password);
    if (data && data.user) {
      setUser(data.user);
    }
    return data;
  }, []);

  const logout = useCallback(async () => {
    await apiLogout();
    setUser(null);
  }, []);

  const hasRole = useCallback(
    (roles) => {
      if (!user) return false;
      if (typeof roles === 'string') return user.role === roles;
      return roles.includes(user.role);
    },
    [user]
  );

  const canAccessDashboard = useCallback(
    () => hasRole(['admin', 'nacional', 'gerente', 'jv']),
    [hasRole]
  );

  const canAccessAdmin = useCallback(
    () => hasRole('admin'),
    [hasRole]
  );

  const value = {
    user,
    loading,
    login,
    logout,
    hasRole,
    canAccessDashboard,
    canAccessAdmin,
    isAuthenticated: !!user,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

